

interface internalToggleState {
  toggleState: boolean;
  handleToggle: () => void;
}

export function Toggle({toggleState, handleToggle}: internalToggleState) {
  return (
    <label
      style={{
        display: "inline-block",
        width: "37px",
        height: "19px",
        position: "relative",
      }}
    >
      <input
        type="checkbox"
        checked={toggleState}
        onChange={handleToggle}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
        }}
      />
      <span
        style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: toggleState ? "#00b86b" : "#ccc",
          transition: "0.4s",
          borderRadius: "34px",
        }}
      />
      <span
        style={{
          position: "absolute",
          cursor: "pointer",
          content: '""',
          height: "13px",
          width: "13px",
          left: toggleState ? "20px" : "4px",
          bottom: "3px",
          backgroundColor: "white",
          transition: "0.4s",
          borderRadius: "50%",
        }}
      />
    </label>
  );
}